import CommonLayout from "../../layouts/CommonLayout";
import { useNavigate } from 'react-router-dom';
import Privacy from '../../../../common/Privacy';

const PrivacyPage = () => {
    const navigate = useNavigate();
    return (
        <CommonLayout title="개인정보 처리방침" onBack={() => navigate('/app/mypage')}>
            <Privacy />
        </CommonLayout>
    );
};

export default PrivacyPage;
